import { Component, Input, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ShopService } from '@app/services/shops/shop.service';
import { DISPLAY_CONDITION_ENTITIES, DISPLAY_CONDITION_RULES } from './display-conditions.model';

@Component({
  selector: 'smart-cart-form-display-conditions',
  templateUrl: './smart-cart-form-display-conditions.component.html',
  styleUrls: ['./smart-cart-form-display-conditions.component.scss'],
  standalone: false,
})
export class SmartCartFormDisplayConditionsComponent {
  @Input() formGroup!: UntypedFormGroup;

  readonly displayRules = DISPLAY_CONDITION_RULES;
  readonly displayRulesEntities = DISPLAY_CONDITION_ENTITIES;
  readonly shopCurrencySymbol: string = inject(ShopService).shopCurrencySymbol || '$';
}
